module.exports = __webpack_public_path__ + "assets/img/index-box2-1.e911ef10.png";